module.exports = __webpack_public_path__ + "tender-bagr.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pictures/tender-bagr.jpg
// module id = 377
// module chunks = 0